import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

interface Herbicide {
  herbicide_id: string
  herbicide_dose: number
}

export interface CreateHerbicideTreatmentPayload {
  treatment_name: string
  herbicides: Herbicide[]
  treatment_cost: number
}

export async function createHerbicideTreatment(
  payload: CreateHerbicideTreatmentPayload,
) {
  await companiesApi.post(apiRoutes.createHerbicideTreatment, payload)
}
